module.exports = __webpack_public_path__ + "static/img/evidence5.a431fd0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/fifth/mo/zh/evidence5.png
// module id = CUuZ
// module chunks = 1 3